module.exports = __webpack_public_path__ + "static/media/Julia Um.f3f6e902.png";